import { render } from "./Cybersecuritynews.vue?vue&type=template&id=23dce80a&scoped=true"
import script from "./Cybersecuritynews.vue?vue&type=script&lang=js"
export * from "./Cybersecuritynews.vue?vue&type=script&lang=js"

import "./Cybersecuritynews.vue?vue&type=style&index=0&id=23dce80a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dce80a"]])

export default __exports__